const messages = {
  title: "Moj osobni izvještaj računa",
  desc: "Ovdje možete vidjeti vaš osobni izvještaj Bridgestone Plus računa s vašim zarađenim i iskorištenim bonus bodovima. Molimo imajte na umu da može proći do 6 tjedana da se bodovi uknjiže za vaše narudžbe guma, ovisno o izvoru.",
  score: "Stanje bodova",
  regularPoints: "Redovni bodovi",
  boosterPoints: "Bonus bodovi",
  date: "Datum",
  supplySourceReason: "Izvor/Razlog za kupovinu",
  article: "Artikal",
  brand: "Brend",
  product: "Proizvod",
  type: "Tip",
  inch: "Inč",
  season: "Sezona",
  amount: "Količina",
  standardPoints: "Bodovi",
  boosterProduct: "Bonus proizvod",
  boosterSeason: "Bonus sezona",
  otherActions: "Druge akcije ili razlozi",
  totalPoints: "Ukupno bodova",
  income: "Prihod",
  spending: "Rashodi",
  lastMonth: "Završno stanje",
  loadMore: "Učitaj još 20 transakcija",
  typeFilter: "Filtriraj po izvoru",
  dateFilter: "Filtriraj po razdoblju",
  customer_number: "Broj kupca",
  currentPoints: "Trenutni bodovi",
  calculationDate: "Datum izračuna",
  positivePoints: "Pozitivni bodovi",
  negativePoints: "Već potrošeno",
  tyresAmount: "Broj guma po godini",
  pointsTotal: "Ukupno bodova",
  currentPointState: "Trenutno stanje bodova",
  currentKickbackState: "Trenutni kešbek",
  pointsFromCurrentYear: "Dodavanje: bodovi iz tekuće godine ({year})",
  pointsAtRiskOfExpiry: "Bodovi za potrošnju do 31.03.{year}",
  points: "Bodovi",
  noDataFound: "Podaci nisu pronađeni",
  seasons: {
    summer: "Ljeto",
    winter: "Zima",
    all: "Sve sezone",
  },
};
export default {
  messages,
};
